import { render, staticRenderFns } from "./add-renew-contract.vue?vue&type=template&id=9ffbad32&scoped=true&"
import script from "./add-renew-contract.vue?vue&type=script&lang=js&"
export * from "./add-renew-contract.vue?vue&type=script&lang=js&"
import style0 from "./add-renew-contract.vue?vue&type=style&index=0&id=9ffbad32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffbad32",
  null
  
)

export default component.exports